export const markup = '@__display__[id:__id__]';

const PLACEHOLDERS = {
  id: '__id__',
  display: '__display__',
};

const escapeRegex = (str: string) =>
  str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

/**
 * Extracted from https://github.com/signavio/react-mentions/blob/master/src/utils/markupToRegex.js
 * as it's a private API in this lib
 */
export const markupToRegex = (value: string): RegExp => {
  const escapedMarkup = escapeRegex(value);
  const charAfterDisplay =
    value[value.indexOf(PLACEHOLDERS.display) + PLACEHOLDERS.display.length];
  const charAfterId =
    value[value.indexOf(PLACEHOLDERS.id) + PLACEHOLDERS.id.length];
  return new RegExp(
    escapedMarkup
      .replace(
        PLACEHOLDERS.display,
        `([^${escapeRegex(charAfterDisplay || '')}]+?)`,
      )
      .replace(PLACEHOLDERS.id, `([^${escapeRegex(charAfterId || '')}]+?)`),
  );
};

export const getPlainText = (textWithMentions: string) =>
  textWithMentions.replace(
    markupToRegex(markup),
    (_, display) => `@${display}`,
  );
